var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-breadcrumb',{attrs:{"items":_vm.breadcrumbItems,"aria-label":_vm.__('Commits breadcrumb'),"size":"md"}})
}
var staticRenderFns = []

export { render, staticRenderFns }